var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeat = function SvgHeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.633 4.034-1.5-1.492-1.175 1.175L4.45 5.208zm-2.3 4.716h-2.5v1.667h2.5zm7.5-8.292H9.166v2.459h1.667zm6.208 3.259-1.175-1.175-1.491 1.492 1.175 1.175zm-2.675 11.417 1.492 1.5 1.175-1.175-1.5-1.492zm2.3-6.384v1.667h2.5V8.75zM10 4.584c-2.759 0-5 2.241-5 5s2.241 5 5 5 5-2.242 5-5-2.242-5-5-5m-.834 14.125h1.667V16.25H9.166zM2.958 15.45l1.175 1.175 1.492-1.5L4.45 13.95z"
  })));
};
export default SvgHeat;